import { extendTheme } from '@chakra-ui/react';

// Supports weights 100-900
import '@fontsource-variable/inter';

const breakpoints = {
  sm: '0',
  md: '768px',
  lg: '1024px',
  xl: '1200px',
  '2xl': '1440px',
};

const theme = extendTheme((chakraTheme) => ({
  ...chakraTheme,

  breakpoints,

  styles: {
    global: {
      body: {
        lineHeight: 'normal',
      },
    },
  },

  colors: {
    ...chakraTheme.colors,

    transparent: 'transparent',
    white: '#ffffff',
    black: '#000000',

    gray: {
      100: '#D9D9D9',
      200: '#E2E8F0',
      500: '#656565',
      600: '#353535',
      700: '#2F2F2F',
      900: '#252525',
    },

    primary: '#F89634',
    secondary: '#00B5D8',

    button: {
      500: '#F89634',
    },
  },

  fonts: {
    heading: `'Inter Variable', sans-serif`,
    body: `'Inter Variable', sans-serif`,
  },

  textStyles: {
    inter8Light: {
      fontSize: ['8px'],
      fontWeight: '300',
      letterSpacing: '2px',
    },

    inter8Regular: {
      fontSize: ['8px'],
      fontWeight: '400',
      letterSpacing: '2px',
    },

    inter8Bold: {
      fontSize: ['8px'],
      fontWeight: '700',
      letterSpacing: '2px',
    },

    inter9Light: {
      fontSize: ['9px'],
      fontWeight: '300',
      letterSpacing: '2.25px',
    },

    inter9Regular: {
      fontSize: ['9px'],
      fontWeight: '400',
      letterSpacing: '2.25px',
    },

    inter9Bold: {
      fontSize: ['9px'],
      fontWeight: '700',
      letterSpacing: '2.25px',
    },

    inter10Light: {
      fontSize: {
        base: '11px',
        md: '10px',
      },
      fontWeight: '300',
      letterSpacing: {
        base: '1px',
        md: '2.5px',
      },
      lineHeight: '1.5',
    },

    inter10Regular: {
      fontSize: {
        base: '11px',
        md: '10px',
      },
      fontWeight: '400',
      letterSpacing: {
        base: '1px',
        md: '2.5px',
      },
      lineHeight: '1.5',
    },

    inter10Bold: {
      fontSize: {
        base: '11px',
        md: '10px',
      },
      fontWeight: '700',
      letterSpacing: {
        base: '1px',
        md: '2.5px',
      },
      lineHeight: '1.5',
    },

    inter12LightNav: {
      fontSize: ['14px'],
      fontWeight: '300',
      letterSpacing: '2.5px',
    },

    inter12BoldNav: {
      fontSize: ['14px'],
      fontWeight: '700',
      letterSpacing: '2.5px',
    },

    inter12Light: {
      fontSize: {
        base: '14px',
        md: '12px',
      },
      fontWeight: '300',
      letterSpacing: {
        base: '0.75px',
        md: '1.5px',
      },
      lineHeight: {
        base: '1.55',
        md: 'normal',
      },
    },

    inter12Regular: {
      fontSize: {
        base: '14px',
        md: '12px',
      },
      fontWeight: '400',
      letterSpacing: {
        base: '0.75px',
        md: '1.5px',
      },
      lineHeight: {
        base: '1.55',
        md: 'normal',
      },
    },

    inter12Bold: {
      fontSize: {
        base: '14px',
        md: '12px',
      },
      fontWeight: '700',
      letterSpacing: {
        base: '0.75px',
        md: '1.5px',
      },
      lineHeight: {
        base: '1.55',
        md: 'normal',
      },
    },

    inter14Light: {
      fontSize: {
        base: '15px',
        md: '14px',
      },
      fontWeight: '300',
      letterSpacing: {
        base: '0.75px',
        md: '1.5px',
      },
      lineHeight: {
        base: '1.55',
        md: 'normal',
      },
    },

    inter14Regular: {
      fontSize: {
        base: '15px',
        md: '14px',
      },
      fontWeight: '400',
      letterSpacing: {
        base: '0.75px',
        md: '1.5px',
      },
      lineHeight: {
        base: '1.55',
        md: 'normal',
      },
    },

    inter14Bold: {
      fontSize: {
        base: '15px',
        md: '14px',
      },
      fontWeight: '700',
      letterSpacing: {
        base: '0.75px',
        md: '1.5px',
      },
      lineHeight: {
        base: '1.55',
        md: 'normal',
      },
    },

    inter16Light: {
      fontSize: ['16px'],
      fontWeight: '300',
      letterSpacing: '2.5px',
    },

    inter16Regular: {
      fontSize: ['16px'],
      fontWeight: '400',
      letterSpacing: '2.5px',
    },

    inter16Bold: {
      fontSize: ['16px'],
      fontWeight: '700',
      letterSpacing: '2.5px',
    },

    inter18Light: {
      fontSize: ['18px'],
      fontWeight: '300',
      letterSpacing: '4.5px',
    },

    inter18Regular: {
      fontSize: ['18px'],
      fontWeight: '400',
      letterSpacing: '4.5px',
    },

    inter18Bold: {
      fontSize: ['18px'],
      fontWeight: '700',
      letterSpacing: '4.5px',
    },

    inter20Light: {
      fontSize: ['20px'],
      fontWeight: '300',
      letterSpacing: '5px',
    },

    inter20Regular: {
      fontSize: ['20px'],
      fontWeight: '400',
      letterSpacing: '5px',
    },

    inter20Bold: {
      fontSize: ['20px'],
      fontWeight: '700',
      letterSpacing: '5px',
    },

    inter32Light: {
      fontSize: ['32px'],
      fontWeight: '300',
      letterSpacing: '5px',
    },

    inter32Regular: {
      fontSize: ['32px'],
      fontWeight: '400',
      letterSpacing: '5px',
    },

    inter32Bold: {
      fontSize: ['32px'],
      fontWeight: '700',
      letterSpacing: '5px',
    },

    inter60Bold: {
      fontSize: ['60px'],
      fontWeight: '700',
      letterSpacing: '15px',
    },

    inter96Bold: {
      fontSize: ['96px'],
      fontWeight: '700',
      letterSpacing: '24px',
    },
  },
}));

export default theme;